import { formatPrice, Env } from '@voghion/fe-util'

/**
 * 设置
 * @returns
 */
export const useSetting = () => {
  return {
    /**
     * 更新 clientInfo
     * @param value
     */
    updateClientInfo(value) {
      const env = Env.getInstance()
      env.clientInfo = value
    },
    /**
     * 获取 clientInfo
     * @returns {Record<string, any>}
     */
    getClientInfo() {
      const env = Env.getInstance()
      return env.clientInfo
    },
    /**
     * 更新 commonInfo
     * @param value
     */
    updateCommonInfo(value) {
      const env = Env.getInstance()
      env.commonInfo = value
    },
    /**
     * 获取 commonInfo
     * @returns
     */
    getCommonInfo() {
      const env = Env.getInstance()
      return env.commonInfo
    },
    /**
     * 格式化价格
     * @param price
     * @returns
     */
    formatPrice(price) {
      const env = Env.getInstance()
      const priceRuler = env.commonInfo?.priceRuler || ''
      const currency = env.clientInfo.currency || 'EUR'
      return formatPrice(price, priceRuler || currency)
    }
  }
}
